import { createAction, props } from '@ngrx/store';

export const ActivateSessionHandoff = createAction('[Session Handoff] Activate Session Handoff');

/**
 * `isWaitingRoom` gates the waiting-room-viewed dispatch in `joinSessionSuccess$`. Optional
 * because the welcome page dispatches `JoinSession` too and must never opt in.
 */
export const JoinSession = createAction(
  '[Session Handoff] Join Session',
  props<{ payload: { packageUserGuid: string; isWaitingRoom?: boolean } }>()
);

export const JoinSessionSuccess = createAction(
  '[Session Handoff] Join Session Success',
  props<{ payload: { packageUserGuid: string; isWaitingRoom?: boolean } }>()
);

export const ContinueToSession = createAction('[Session Handoff] Continue To Session');

export const AddAssociatedUser = createAction(
  '[Session Handoff] Add Associated User',
  props<{ payload: { packageUserGuid: string } }>()
);
